export default {"src":"/_next/static/media/twitter.0d474ea9.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};